var AssessmentViewService = require('services/assessment-service');
var CourseSettingsService = require('services/course-settings-service');

var AssessmentService = function() {
  this.triggerAssessment = function(blockView){
    var url = AssessmentViewService.getUrl(blockView.model.get('assessment_slug'));
    if(url === undefined){
      blockView.readyToGo();
      Chaplin.mediator.publish('page:navigate', 'forward');
    }
    else{
      setTimeout(_.bind(function(){
        Chaplin.mediator.publish('window:navigate', url);
      }, this), 2000);
    }
  };

  this.loadCourseAssessment = function(view) {
    view.assessment = AssessmentViewService.getAssessment(view.model.get('assessment_slug'));
    let failToLocal = CourseSettingsService.get('loadLocalAssessments');
    view.assessment.set('subtext', view.model.get('subtext'));
    return view.assessment.loadAssessment({
      split_questions: Boolean(view.model.get('split_questions')),
      failToLocal
    });
  };

  this.userHasCompletedAssessment = function(courseSlug){
    return AssessmentViewService.getActivityProgressForSlug(courseSlug, false).length > 0;
  };

  this.getBestScore = function(courseSlug){
    var attempts = AssessmentViewService.getActivityProgressForSlug(courseSlug, true);
    if (attempts.length === 0){
      return null;
    } else {
      return _.max(attempts.map( function(attempt) { return attempt.get('grade'); }));
    }
  };

  this.getUrl = function(assessment) {
    return EF.url('/sdk/enrollments/' + EF.enrollment.get('id') + '/assessments/' + assessment.get('slug') + '.json');
  };

  this.isAttemptCorrect = function(results) {
    return results.last_answer_correct;
  };
  this.isAttemptComplete = function (attempt) {
    var questions = attempt.assessment.get('original_questions') || this.assessment.get('questions');
    return questions.every(function (q) {
      return !!(attempt.get(q.get('id')));
    });
  };
  this.isAttemptFinished = function (attempt) {
    return attempt.get('state') === 'passed' || attempt.get('state') === 'failed';
  };
  this.parseAttempt = function(data){
    return data;
  }
  this.refreshActivityProgress = function () {
    EF.activityProgresses.fetch();
  };
};

module.exports = new AssessmentService();
